export const removeSpecialCharacters = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, ""); // Remove special characters
};

export const highlightText = (text: string, keyword: string) => {
  if (!keyword) {
    return text;
  }
  const escapedKeyword = removeSpecialCharacters(keyword);
  const regex = new RegExp(`(${escapedKeyword})`, "gi");
  // eslint-disable-next-line @faire/no-dollar-symbol-in-strings
  return text.replace(regex, "<strong>$1</strong>");
};
